<template>
    <div class="header-body">
        <div class="header-logo">
            <img class="icon" :src="$R(systemConfigStore.getConfig?.SystemLogo)" style="width: 50px; height: 50px;"
                alt="">
        </div>
        <div class="header-menu">
            <var-tabs v-model:active="active">
                <var-tab @click="OpenMenu(index)" v-for="(m, index) in menus">{{ m.name }}</var-tab>
            </var-tabs>
        </div>
        <div class="right-content">
            <ClockComponent></ClockComponent>
            <AIPopupComponent></AIPopupComponent>
            <var-button color="transparent" round text style="height: 100%;">
                <var-icon v-if="themeStore.getThemeName == 'dark'" namespace="icon" @click="SetTheme('light')"
                    name="yejing" :size="20" />
                <var-icon v-else namespace="icon" @click="SetTheme('dark')" name="lieri" :size="20" />
            </var-button>

            <var-menu v-model:show="languageStatusStore.show" placement="bottom-end" style="height: 100%;">
                <var-button color="transparent" round text style="height: 100%;">
                    <var-icon namespace="icon" name="duoyuyan" :size="20" />
                </var-button>

                <template #menu>
                    <LanguageComponent></LanguageComponent>
                    <!-- <var-cell @click="SetLocale(key)" v-for="(v, key) in messages" ripple>{{ key }}</var-cell> -->
                </template>
            </var-menu>
        </div>
    </div>
</template>

<script lang="tsx" setup>
import { useLocaleStore } from '@/store/locale';
import { useThemeStore } from '@/store/theme';
import { Locale } from '@varlet/ui';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AIPopupComponent from '../AiComponents/AIPopupComponent.vue';
import Tools from '@/utils/Tools';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useLocale } from '@/hooks/useLocale';
import LanguageComponent from '../GlobalComponents/LanguageComponent.vue';
import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import ClockComponent from '../GlobalComponents/ClockComponent.vue';
const router = useRouter();
const route = useRoute();
const locale = useLocaleStore();
const systemConfigStore = useSystemConfigStore();
const themeStore = useThemeStore();
const languageStatusStore = useLanguageStatusStore();
const local = useLocale();
const messages = Locale.messages;

const active = ref(0);

// const menuComputed = computed()

const menus = computed(() => [
    {
        name: local.t('components.HeaderComponent.home'),
        path: '/'
    },
    {
        name: local.t('components.HeaderComponent.heyue'),
        path: '/contract'
    },
    {
        name: local.t('components.HeaderComponent.qiquan'),
        path: '/options'
    },
    {
        name: local.t('components.HeaderComponent.xianhuo'),
        path: '/transaction'
    },
    {
        name: local.t('route.me.menus.daikuan'),
        path: '/loans'
    },
    {
        name: local.t('components.HeaderComponent.wode'),
        path: '/me'
    },
    {
        name: local.t('components.HeaderComponent.about'),
        path: '/about'
    },
    // {
    //     name: local.t('components.HeaderComponent.ptjj'),
    //     path: '/introduction'
    // },
    // {
    //     name: local.t('components.HeaderComponent.dingyue'),
    //     path: '/subscribe'
    // }
]);


watch(() => route.path, (n, o) => {
    for (let i = 0; i < menus.value.length; i++) {
        if (menus.value[i].path === n) {
            active.value = i;
            return;
        }
    }
}, {
    immediate: true
});

/**
 * 跳转页面
 * @param index 
 */
function OpenMenu(index: number) {
    router.push(menus.value[index].path);
}


function SetTheme(themeKey: 'light' | 'dark') {
    themeStore.setTheme(themeKey);
}

</script>

<style lang="scss" style="scoped">
.header-body {
    display: flex;
    width: 100%;
    height: 80px;
    min-height: 80px;
    max-height: 80px;
    padding: 0px 10px;
    box-sizing: border-box;
    // background: var(--tabs-background);
    align-items: center;

    .header-logo {
        padding: 10px;

        .icon {
            border-radius: 50%;
        }
    }

    .header-menu {
        display: flex;
        align-items: center;
        flex-grow: 1;
        overflow: hidden;

        .ai-icon {
            width: 25px;
            height: 25px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            border-radius: 50%;
            overflow: hidden;

            .ai-icon-image {
                width: 100%;
                height: 100%;
            }
        }
    }

    .right-content {
        margin-left: auto;
        display: flex;
        align-items: center;


    }
}
</style>